// Deliberately makes no claim about whether the test passed. The landing URL is user-visible and
// forgeable, so a verdict rendered here would be spoofable.
export const SSO_TEST_COMPLETE_LABELS = {
  TITLE: 'The test sign-in is finished',
  DESCRIPTION: 'You can close this tab and go back to the NetRise window where you started the test.',
  DOCUMENT_TITLE: 'SSO Test - NetRise'
};
